import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

interface Props {
  timeInSeconds: number;
}

export const CountDownTimer = ({ timeInSeconds }: Props) => {
  const { t } = useTranslation('digital-forms-experience');

  const minutes = Math.floor(timeInSeconds / 60)
    .toString()
    .padStart(2, '0');
  const seconds = (timeInSeconds % 60).toString().padStart(2, '0');

  return (
    <div css={containerStyle}>
      <Icon name='clock' color='subdued' size={22} aria-label={t('Timer icon')} />
      <div css={countItemContainerStyle}>
        <Text as='span' color='subdued'>
          {minutes}
        </Text>
        <Text as='span' color='subdued' size='small'>
          {t('Min')}
        </Text>
      </div>
      <Text as='span' color='subdued' css={separatorStyle}>
        :
      </Text>
      <div css={countItemContainerStyle}>
        <Text as='span' color='subdued'>
          {seconds}
        </Text>
        <Text as='span' color='subdued' size='small'>
          {t('Sec')}
        </Text>
      </div>
    </div>
  );
};

const containerStyle = css({
  display: 'flex',
  svg: {
    margin: theme.spacing(0.5, 0.5, 0, 0),
  },
});

const countItemContainerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: 25,
  span: {
    color: theme.colors.neutral40,
    ':first-child': {
      fontSize: theme.fontSize(20),
    },
  },
});
const separatorStyle = css({
  fontSize: theme.fontSize(20),
  margin: theme.spacing(0, 0.25),
  lineHeight: 1.35,
});
